// Чистая логика «какие оверлеи включены» — отделена от эффекта рендера (useOverlays),
// чтобы тестироваться без карты. Тайл-оверлеи (лёд/туман/облачность) рисуются растром,
// землетрясения — geojson-слоем, луна — виджетом (не слой карты).

export const TILE_OVERLAYS = ['ice', 'sea_fog', 'clouds'] as const

/** Для каждого тайл-оверлея — должен ли он быть на карте при данном наборе active. */
export function tileOverlayState(active: string[]): Record<string, boolean> {
  const out: Record<string, boolean> = {}
  for (const id of TILE_OVERLAYS) out[id] = active.includes(id)
  return out
}

/** Не-тайловые оверлеи: землетрясения (geojson) и луна (виджет). */
export function overlayFlags(active: string[]): { earthquakes: boolean; moon: boolean } {
  return {
    earthquakes: active.includes('earthquakes'),
    moon: active.includes('moon'),
  }
}
